import { VStack, Box, Text, Heading } from '@chakra-ui/react';
import { format } from 'date-fns';
import { ClockIcon, LocationPinIcon } from '../../icons';
import type { IEvent } from '../../../lib';

interface IEventDetailsProps {
	event: IEvent;
	isSameDayEvent: boolean;
	eventTooltipTextColor: string;
	monthFormat: string;
	timeFormat: string;
	isListItem: boolean;
	haveFeaturedImage: boolean;
	parentRef: any;
	eventPopoverColor: string;
}

export const EventDetails = ({
	event,
	isSameDayEvent,
	eventTooltipTextColor,
	timeFormat,
	monthFormat,
	isListItem,
	haveFeaturedImage,
	parentRef,
	eventPopoverColor,
}: IEventDetailsProps) => {
	return (
		<VStack
			ref={parentRef}
			gap={1}
			alignItems='flex-start'
			px={6}
			pt={2}
			pb={6}
			background={haveFeaturedImage ? eventPopoverColor : ''}
			width={isListItem ? 'full' : 'inherit'}
		>
			<Box
				maxH='4.5em'
				overflow='hidden'
				textOverflow='ellipsis'
				whiteSpace='normal'
				display='-webkit-box'
				sx={{
					WebkitBoxOrient: 'vertical',
					WebkitLineClamp: 2,
				}}
			>
				<Heading
					fontSize={isListItem ? '18px' : '30px'}
					fontWeight='900'
					color={`${eventTooltipTextColor} !important`}
				>
					{event.title}
				</Heading>
			</Box>

			<Text
				alignItems='baseline'
				color={eventTooltipTextColor}
				display='flex'
				fontSize='.9rem'
				fontWeight={600}
				m={0}
			>
				<ClockIcon
					size={12}
					fill={eventTooltipTextColor}
					style={{ marginRight: '.375rem', position: 'relative', top: '1px' }}
				/>
				{format(event.start, isSameDayEvent ? timeFormat : `${monthFormat} ${timeFormat}`)} -{' '}
				{format(event.end, isSameDayEvent ? timeFormat : `${monthFormat} ${timeFormat}`)}
			</Text>
			{event.venue && (
				<Text
					alignItems='baseline'
					color={eventTooltipTextColor}
					display='flex'
					fontSize='.9rem'
					fontWeight={600}
					m={0}
				>
					<LocationPinIcon
						size={12}
						fill={eventTooltipTextColor}
						style={{ marginRight: '.375rem', position: 'relative', top: '1px' }}
					/>
					{event.venue}
				</Text>
			)}
		</VStack>
	);
};
